// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdBrand_importCsvCard__YAA3D","addProdBrandBtnContainer":"AddProdBrand_addProdBrandBtnContainer__G6k8Y"};